if (!customElements.get('bonbons-bar')) {
  class BonbonsBar extends customElements.get('slider-default') {
    constructor() {
      super();

      this.bonbonsGrid = document.querySelector('bonbons-grid');
      this.errorPopup = document.querySelector('error-popup');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.bonbonsInput = document.querySelector('[data-input-bonbons]');
      this.boxSizeInput = document.querySelector('[name="box_size"]');
      this.variantIdInput = this.querySelector('[name="id"]');
      this.quantityInput = this.querySelector('[name="quantity"]');
      this.countEl = this.querySelectorAll('[data-count]');
      this.submitButtons = this.querySelectorAll('[name="add"]');
      this.switchSizeButton = this.querySelector('[data-switch-size]');
      this.backButton = this.querySelector('[data-button-back]');
      this.scrollButton = document.querySelector('[data-button-scroll-back]');
      this.prices = JSON.parse(
        this.querySelector('[data-variants-prices]').textContent,
      );
      this.priceContainers = document.querySelectorAll('[data-box-price]');

      this.initObserver();

      this.backButton.addEventListener('click', () => {
        this.boxSizeInput.dispatchEvent(new Event('change'));
      });

      this.scrollButton.addEventListener('click', () => {
        this.bonbonsGrid.parentElement.scrollIntoView();
      });

      this.switchSizeButton.addEventListener('click', () => {
        this.classList.remove('is-filled');
        this.classList.add('is-edit');
      });

      this.querySelector('form').addEventListener('submit', (e) => {
        e.preventDefault();

        this.formatBonbonsField();
        this.submitButtons.forEach((button) =>
          button.classList.add('disabled'),
        );

        const formData = new FormData(this.querySelector('form'));
        formData.append(
          'sections',
          this.cartDrawer
            .getSectionsToRender()
            .map((section) => section.section),
        );
        formData.append('sections_url', window.location.pathname);

        Cart.add(formData)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            this.cartDrawer.renderContents(response);
            this.resetBar();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButtons.forEach((button) =>
              button.classList.remove('disabled'),
            );
          });
      });

      this.boxSizeInput.addEventListener(
        'change',
        this.updateBoxSize.bind(this),
      );

      this.quantityInput.addEventListener(
        'change',
        this.updatePrice.bind(this),
      );
    }

    resetBar() {
      this.slider.slideTo(0);
      this.removeAllBonbons();
    }

    initObserver() {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          const isAboveTarget = entry.boundingClientRect.top > 0;
          const isHidden =
            !entry.isIntersecting && isAboveTarget && this.isBarEmpty();

          this.toggleVisibility(!isHidden);

          if (this.classList.contains('is-filled')) return;

          const isBelowTarget = entry.boundingClientRect.bottom < 0;
          const hasScrolledPast = !entry.isIntersecting && isBelowTarget;

          this.classList.toggle('is-scrolled', hasScrolledPast);
        },
        {
          root: null,
          threshold: 0,
          rootMargin: `0px 0px -140px 0px`,
        },
      );

      this.observer.observe(this.bonbonsGrid);
    }

    isBarEmpty() {
      return !this.bonbonsInput.value;
    }

    updatePrice() {
      const price = this.prices.find((priceObj) => {
        return +priceObj.id === +this.variantIdInput.value;
      });

      this.priceContainers.forEach((priceContainer) => {
        const isDynamic = priceContainer.hasAttribute('data-dynamic');
        const isMain = priceContainer.dataset.boxPrice == 'main';
        const priceValue = isDynamic
          ? price.price_value * +this.quantityInput.value
          : price.price_value;

        if (isMain) {
          clearTimeout(this.priceAnimationTimeout);

          priceContainer.classList.add('is-hidden');

          this.priceAnimationTimeout = setTimeout(() => {
            priceContainer.innerHTML = Shopify.formatMoney(priceValue).replace(
              '.00',
              '',
            );
            priceContainer.classList.remove('is-hidden');
          }, 200);

          return;
        }

        priceContainer.innerHTML = Shopify.formatMoney(priceValue).replace(
          '.00',
          '',
        );
      });
    }

    updateBoxSize() {
      this.slider.slides.forEach((slide, index) => {
        slide.classList.remove('is-disabled');
        slide.classList.toggle('is-hidden', index >= +this.boxSizeInput.value);
      });
      this.slider.update();
      this.updatePrice();
      this.updateCount();
      this.classList.remove('is-edit', 'is-confirm');
    }

    formatBonbonsField() {
      const uniqueBonbons = [];
      const addedBonbonsArray = this.bonbonsInput.value.split(', ');

      if (addedBonbonsArray.length < +this.boxSizeInput.value) {
        this.errorPopup.showPopup(this.bonbonsInput.dataset.errorBelowLimit);

        return;
      }

      addedBonbonsArray.forEach((bonbon, index) => {
        if (+this.boxSizeInput.value < index + 1) return;

        const matchingBonbon = uniqueBonbons.find(
          (bonbonObj) => bonbonObj.title === bonbon,
        );

        if (matchingBonbon) {
          ++matchingBonbon.count;

          return;
        }

        uniqueBonbons.push({
          title: bonbon,
          count: 1,
        });
      });

      const uniqueBonbonsString = uniqueBonbons.reduce((acc, bonbonObj, i) => {
        acc += `${bonbonObj.count} x ${bonbonObj.title}`;

        if (uniqueBonbons.length > 1 && i < uniqueBonbons.length - 1)
          acc = `${acc}\n `;

        return acc;
      }, '');

      this.bonbonsInput.value = uniqueBonbonsString;
    }

    toggleVisibility(isVisible = true) {
      this.bonbonsInput.toggleAttribute('disabled', !isVisible);
      this.classList.toggle('is-visible', isVisible);
      document.body.classList.toggle('is-bar-visible', isVisible);
    }

    updateCount() {
      const emptyMedia = this.querySelectorAll(
        '.swiper-slide:not(.is-hidden) .media:empty',
      );

      this.countEl.forEach((count) => {
        count.dataset.count = emptyMedia.length;
      });

      this.classList.toggle('is-filled', !emptyMedia.length > 0);
    }

    updateActiveSlide(emptySlide) {
      const slideOffset =
        emptySlide.offsetParent.offsetWidth -
        (emptySlide.offsetLeft + emptySlide.offsetWidth);

      if (slideOffset <= 0) this.slider.slideNext();
    }

    removeAllBonbons() {
      this.bonbonsInput.value = '';
      this.classList.remove('is-filled');
      this.toggleVisibility(false);

      this.slider.slides.forEach((slide) => {
        const image = slide.querySelector('img');

        image?.remove();
      });
    }
  }

  customElements.define('bonbons-bar', BonbonsBar);
}

if (!customElements.get('card-bonbon')) {
  class CardBonbon extends HTMLElement {
    static instances = new Set();
    static bonbonsBar = document.querySelector('bonbons-bar');

    constructor() {
      super();

      CardBonbon.instances.add(this);

      this.bonbonsBar = CardBonbon.bonbonsBar;
      this.bonbonsInput = this.bonbonsBar.bonbonsInput;
      this.popup = this.querySelector('[data-bonbon-popup]');
      this.buttonAdd = this.querySelector('[data-bonbon-add]');

      this.addEventListener('click', (e) => {
        if (!hoverMedia.matches) {
          const clickedBonbon = CardBonbon.getInstances().find(
            (item) => item.classList.contains('is-clicked') && item !== this,
          );

          this.classList.toggle('is-clicked');

          clickedBonbon?.classList.remove('is-clicked');

          return;
        }

        this.addBonbon();
      });

      this.buttonAdd?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.addBonbon();
      });

      this.popup?.addEventListener('click', (e) => {
        e.stopPropagation();

        const isButtonClose = e.target.hasAttribute('data-bonbon-close');
        if (!isButtonClose) return;

        e.preventDefault();
        this.classList.remove('is-clicked');
      });
    }

    disconnectedCallback() {
      CardBonbon.instances.delete(this);
    }

    addBonbon() {
      const emptyMedia = this.bonbonsBar.querySelector(
        '.swiper-slide:not(.is-hidden) .media:empty',
      );

      if (!emptyMedia) {
        this.bonbonsBar.errorPopup.showPopup(
          this.bonbonsInput.dataset.errorAboveLimit,
        );

        return;
      }

      const emptyItem = emptyMedia.closest('.swiper-slide');
      const titleWrapper = emptyItem.querySelector('[data-title]');

      const image = document.createElement('img');
      if (this.dataset.imageSrc) image.src = this.dataset.imageSrc;
      image.addEventListener('load', (e) => {
        image.classList.add('is-loaded');
      });

      titleWrapper.dataset.title = this.dataset.title;
      emptyMedia.insertAdjacentElement('beforeend', image);

      this.bonbonsBar.updateActiveSlide(emptyItem);
      this.bonbonsBar.updateCount();
      this.bonbonsBar.toggleVisibility();

      this.bonbonsInput.value
        ? (this.bonbonsInput.value = `${this.bonbonsInput.value}, ${this.dataset.title}`)
        : (this.bonbonsInput.value = this.dataset.title);
    }

    static getInstances() {
      return [...CardBonbon.instances];
    }
  }

  customElements.define('card-bonbon', CardBonbon);
}

if (!customElements.get('bonbon-remove')) {
  class BonbonRemove extends HTMLElement {
    constructor() {
      super();

      this.bonbonsBar = document.querySelector('bonbons-bar');

      this.addEventListener('click', (e) => {
        const isAnimating = this.parentElement.classList.contains('is-removed');

        if (this.bonbonsBar.classList.contains('is-edit') || isAnimating)
          return;

        this.handleBonbonRemove();
      });
    }

    handleBonbonRemove() {
      const addedBonbonsArray = this.bonbonsBar.bonbonsInput.value.split(', ');
      const slides = Array.from(this.bonbonsBar.slider.slides);
      const currentSlide = this.parentElement;
      const removedBonbonIndex = slides.findIndex(
        (slide) => currentSlide === slide,
      );

      if (removedBonbonIndex !== -1) {
        addedBonbonsArray.splice(removedBonbonIndex, 1);
      }

      this.bonbonsBar.bonbonsInput.value = addedBonbonsArray.join(', ');

      currentSlide.classList.add('is-removed');

      currentSlide.addEventListener(
        'animationend',
        (e) => {
          this.removeBonbon();
          this.updateBar();
        },
        { once: true },
      );
    }

    updateBar() {
      const filledSlide = this.bonbonsBar.querySelector(
        '.swiper-slide:not(.is-hidden) .media:not(:empty)',
      );

      this.bonbonsBar.slider.update();
      this.updateNumbers();
      this.bonbonsBar.updateCount();
      this.bonbonsBar.toggleVisibility(filledSlide);
    }

    updateNumbers() {
      this.bonbonsBar.slider.slides.forEach((slide, index) => {
        const numberEl = slide.querySelector('[data-number]');

        numberEl.textContent = ++index;
      });
    }

    removeBonbon() {
      const currentSlide = this.parentElement;
      const firstHiddenSlide = this.bonbonsBar.querySelector(
        '.swiper-slide.is-hidden',
      );

      if (firstHiddenSlide) {
        this.bonbonsBar.slider.wrapperEl.appendChild(currentSlide);
        currentSlide.classList.add('is-hidden');
        firstHiddenSlide.classList.remove('is-hidden');
      }

      currentSlide.querySelector('img').remove();
      currentSlide.classList.remove('is-removed');
    }
  }

  customElements.define('bonbon-remove', BonbonRemove);
}

if (!customElements.get('box-image-slider')) {
  class BoxImageSlider extends customElements.get('slider-default') {
    constructor() {
      super();

      this.bonbonsBar = document.querySelector('bonbons-bar');
      this.boxSizeInput = this.bonbonsBar.boxSizeInput;
      this.slides = Array.from(this.slider.slides);

      this.slider.on('activeIndexChange', this.updateBoxSizeInput.bind(this));
      this.boxSizeInput.addEventListener(
        'change',
        this.setActiveImage.bind(this),
      );
    }

    updateBoxSizeInput() {
      const activeSlide = this.slides[this.slider.activeIndex];

      this.bonbonsBar.variantIdInput.value = activeSlide.dataset.variantId;
      this.boxSizeInput.value = activeSlide.dataset.boxSize;
      this.boxSizeInput.dispatchEvent(new Event('change'));
    }

    setActiveImage() {
      const newSlideIndex = this.slides.findIndex(
        (slide) => slide.dataset.boxSize === this.boxSizeInput.value,
      );

      if (newSlideIndex === this.slider.activeIndex) return;

      this.slider.slideTo(newSlideIndex);
    }
  }

  customElements.define('box-image-slider', BoxImageSlider);
}
